import React from "react";
import LocalLibraryRoundedIcon from "@mui/icons-material/LocalLibraryRounded";

const SupportIcon = ({ size = 24 }) => {
  return (
    <LocalLibraryRoundedIcon
      sx={{
        fontSize: size,
        transition: "none",
      }}
    />
  );
};

export default SupportIcon;
